var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 0.25C6.88943 0.25273 4.50645 1.24133 2.74889 2.99889C0.991327 4.75645 0.00272962 7.13943 0 9.625V17.5309C0.000496137 17.9204 0.155431 18.2938 0.430826 18.5692C0.706222 18.8446 1.0796 18.9995 1.46906 19H9.375C11.8614 19 14.246 18.0123 16.0041 16.2541C17.7623 14.496 18.75 12.1114 18.75 9.625C18.75 7.1386 17.7623 4.75403 16.0041 2.99587C14.246 1.23772 11.8614 0.25 9.375 0.25ZM9.375 17.5H1.5V9.625C1.5 8.06747 1.96186 6.54492 2.82718 5.24988C3.69249 3.95485 4.9224 2.94549 6.36137 2.34945C7.80034 1.75341 9.38374 1.59746 10.9113 1.90132C12.4389 2.20517 13.8421 2.9552 14.9435 4.05653C16.0448 5.15787 16.7948 6.56106 17.0987 8.08866C17.4025 9.61626 17.2466 11.1997 16.6506 12.6386C16.0545 14.0776 15.0452 15.3075 13.7501 16.1728C12.4551 17.0381 10.9325 17.5 9.375 17.5Z",
    fill: "#ABB1BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassigned);
export default __webpack_public_path__ + "static/media/Unassigned.8d8949a73ee10c20528db6315a8eea36.svg";
export { ForwardRef as ReactComponent };